const countries = [
  { label: "India", value: "in" },
  { label: "USA", value: "us" }
];

export default countries;
